import { render, staticRenderFns } from "./Evection.vue?vue&type=template&id=01ffea64&scoped=true"
import script from "./Evection.vue?vue&type=script&lang=js"
export * from "./Evection.vue?vue&type=script&lang=js"
import style0 from "./Evection.vue?vue&type=style&index=0&id=01ffea64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffea64",
  null
  
)

export default component.exports